import React, { Component } from "react";
import styled from "styled-components";

const D = [
  "M38.2629377,93.2128895",
  "C38.2629377,93.2128895",
  "36.1962893,95.8583973",
  "25.0312502,102.801757",
  "C25.0312502,105.872069",
  "25.03125,136.238281",
  "25.03125,136.238281",
  "L77.2128906,136.238281",
  "L77.2128873,102.801755",
  "C77.2128873,102.801755",
  "60.9166814,91.6755215",
  "52.0566401,85.3017568",
  "C43.5599106,79.1893524",
  "-4.7958983,51.5576161",
  "6.49316412,18.9160159",
  "C20.0507814,-7.03710907",
  "51.0566427,8.31298816",
  "51.0566427,20.8496086",
  "C51.0566427,8.31298819",
  "82.0830073,-7.06250021",
  "94.8701183,18.9160155",
  "C108.299804,54.568358",
  "51.0566439,83.9995107",
  "51.0566439,83.9995107"
];

const getHeightStyles = (height, theme) => {
  if (typeof height === "string") {
    return `height: ${height}`;
  }

  const defaultHeight = height.default ? `height: ${height.default};` : "";

  // prettier-ignore
  const screenSizeHeights = Object.entries(theme.screen).reduce(
    (accum, [key]) => height[key] ?
      accum.concat(`
        @media (min-width: ${theme.screen[key]}px) {
          height: ${height[key]};
        }
      `)
      : accum,
      ""
  );
  return defaultHeight + screenSizeHeights;
};

const StyledLoadingContainer = styled.div`
  ${({ height = "100vh", theme }) => getHeightStyles(height, theme)}
  display: flex;
  justify-content: center;
  align-items: center;

  .path {
    stroke-dasharray: 460;
    stroke-dashoffset: 460;
    animation: draw-in 3s ease-out;
    animation-iteration-count: infinite;
  }

  @keyframes draw-in {
    0% {
      stroke-dashoffset: -460;
    }
    2% {
      stroke-dashoffset: -460;
    }
    25% {
      stroke-dashoffset: 0;
    }
    75% {
      stroke-dashoffset: 0;
    }
    100% {
      stroke-dashoffset: 460;
    }
  }
`;

class LoadingPlaceholder extends Component {
  render() {
    return (
      <StyledLoadingContainer
        data-testid="loading-placeholder"
        height={this.props.height}
      >
        <svg
          width="51px"
          height="71px"
          viewBox="0 0 103 143"
          version="1.1"
          xlinkHref="http://www.w3.org/1999/xlink"
        >
          <g
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinejoin="round"
          >
            <path
              className="path"
              d={D.join(" ")}
              id="Path-4"
              stroke="#dd6254"
              strokeWidth="9"
            />
          </g>
        </svg>
      </StyledLoadingContainer>
    );
  }
}

export default LoadingPlaceholder;
